import React from 'react';
import {withRouter} from 'react-router';
import Breadcrumbs from 'react-router-dynamic-breadcrumbs';
import BreadcrumbsItem from './BreadcrumbsItem';

const routes = {
  '/': null,
  '/companies': 'Companies',
  '/companies/create': 'Create Company',
  '/companies/:companyId': 'Company Dashboard',
  '/companies/:companyId/contacts': 'Contacts',
  '/companies/:companyId/programs': null,
  '/companies/:companyId/programs/create': 'Create Program',
  '/companies/:companyId/programs/:programId': 'Program Dashboard',
  '/companies/:companyId/programs/:programId/edit': 'Edit Program',
  '/companies/:companyId/programs/:programId/teams': null,
  '/companies/:companyId/programs/:programId/teams/create': 'Create Team',
  '/companies/:companyId/programs/:programId/teams/:teamId/assessment': 'Assessment',
  '/companies/:companyId/programs/:programId/teams/:teamId/edit': 'Edit Team',
  '/companies/:companyId/programs/:programId/teams/:teamId': 'Team Dashboard',
  '/companies/:companyId/programs/:programId/teams/:teamId/selfassessment': null,
  '/companies/:companyId/programs/:programId/teams/:teamId/selfassessment/create': 'Create Self Assessment',
  '/companies/:companyId/programs/:programId/teams/:teamId/reports': null,
  '/companies/:companyId/programs/:programId/teams/:teamId/reports/:reportId': 'Coach Assessment Report',
  '/companies/:companyId/programs/:programId/teams/:teamId/selfreports': null,
  '/companies/:companyId/programs/:programId/teams/:teamId/selfreports/:groupAssessmentId': 'Team Self Assessment Report',
  '/companies/:companyId/engagements': null,
  '/companies/:companyId/engagements/create': 'Propose Engagement',
  '/companies/:companyId/engagements/:engagementId': 'Engagement',
  '/users': 'Users',
  '/surveys': null,
  '/users/create': 'Create User',
  '/users/invite': 'Invite User',
  '/assessments/create/edit-question/:subId/:qId': 'Edit Question',
  '/assessments/create/edit-question/:subId': null,
  '/assessments/create/edit-question': null,
  '/assessments/create/add-question/:subId': 'Add Question',
  '/assessments/create/add-question': null,
  '/assessments/create': 'Create Assessment',
  '/assessments': 'Assessments',
  '/login': null,
  '/verify': null,
  '/forgot': null,
  '/reset': null,
  '/force-password': null
};

class BreadcrumbBar extends React.Component {

  render() {
    return (
      <div className={'BreadcrumbBar'}>
        <Breadcrumbs
          mappedRoutes={routes}
          ActiveLinkComponent={(props) => <BreadcrumbsItem {...props} isActive/> }
          LinkComponent={(props) => <BreadcrumbsItem {...props}/> }
        />
      </div>
    );
  }
}

export default withRouter(BreadcrumbBar);


// WEBPACK FOOTER //
// ./src/components/BreadcrumbBar.js